import { api } from './client';
import type { FilterRule } from '@/types';

export interface FiltersResponse {
  filters: FilterRule[];
}

export interface FilterInput {
  mailboxId?: string | null;
  listType: 'allow' | 'block';
  matchType: 'domain' | 'email' | 'pattern' | 'keyword';
  field?: 'sender' | 'subject' | 'body' | 'any';
  matchValue: string;
}

export async function listFilters(): Promise<FiltersResponse> {
  return api.get<FiltersResponse>('/filters');
}

export async function createFilter(input: FilterInput): Promise<{ filter: FilterRule }> {
  return api.post<{ filter: FilterRule }>('/filters', input);
}

export async function updateFilter(id: string, input: Partial<FilterInput>): Promise<{ filter: FilterRule }> {
  return api.patch<{ filter: FilterRule }>(`/filters/${id}`, input);
}

export async function deleteFilter(id: string): Promise<{ ok: boolean }> {
  return api.delete<{ ok: boolean }>(`/filters/${id}`);
}
